function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H1440V1024H0z",
  transform: "translate(0 -643)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6A7595",
  fillOpacity: 0.26,
  d: "M-34 363h223v76L72.5 487-34 439v-76z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6A7595",
  fillOpacity: 0.26,
  d: "M163 349h223v76l-116.5 48L163 425v-76z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M67.337 442.877l-.045-125.527 100.304-57.98v125.382L67.337 442.877z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M67.337 442.877l-.045-125.527L-33 259.37v125.382l100.337 58.125z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M-19.991 376.403v-96.38l-2.94-1.699v100.203l80.199 46.469v-3.844l-77.259-44.749z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M57.267 421.152l-.033-96.492-77.226-44.637v96.381l77.26 44.748z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M28.064 396.811l21.525 12.472v-32.41l-21.525-12.439v32.377z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99A4C2",
  fillRule: "evenodd",
  d: "M154.598 376.403v-96.38l2.939-1.699v100.203L77.35 424.996v-3.844l77.248-44.749z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M77.35 421.152l.034-96.492 77.214-44.637v96.381L77.35 421.152zM-33 259.37l100.292 57.98 100.304-57.98-100.259-57.969L-33 259.37z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M146.786 260.554l3.32-1.922-82.746-47.844-82.791 47.844 3.319 1.922 79.472-45.932 79.426 45.932z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M145.786 259.554l-79.427-45.932-79.472 45.932 79.45 45.922 79.449-45.922z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M133.722 302.118v32.41l16.551-9.589v-32.377l-16.551 9.556zM109.179 316.043v32.399l16.541-9.578v-32.388l-16.541 9.567zM258.32 447.374l-.034-125.539 100.304-57.969v125.371l-100.27 58.137z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M258.319 447.374l-.033-125.539-100.293-57.969v125.371l100.326 58.137z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M171.002 380.889v-96.381l-2.939-1.699v100.214l80.187 46.458v-3.844l-77.248-44.748z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M248.25 425.637l-.022-96.493-77.225-44.636v96.38l77.247 44.749z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M219.059 401.296l21.524 12.483v-32.421l-21.524-12.439v32.377z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99A4C2",
  fillRule: "evenodd",
  d: "M345.592 380.889v-96.381l2.939-1.699v100.214l-80.187 46.458v-3.844l77.248-44.748z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M268.344 425.637l.022-96.493 77.226-44.636v96.38l-77.248 44.749zM157.993 263.866l100.293 57.969 100.303-57.969-100.27-57.969-100.326 57.969z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M337.781 265.039l3.319-1.922-82.746-47.844-82.791 47.844 3.319 1.922 79.472-45.921 79.427 45.921z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M337.779 265.039l-79.427-45.922-79.471 45.922 79.438 45.922 79.46-45.922z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M324.715 306.625v32.388l16.551-9.578v-32.388l-16.551 9.578zM300.162 320.528v32.399l16.552-9.578v-32.388l-16.552 9.567zM158.025 265.477l-.022-125.527 100.292-57.98v125.37l-100.27 58.137z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M158.026 265.477l-.023-125.527L57.7 81.97v125.37l100.326 58.137z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M70.708 198.992v-96.381l-2.939-1.699v100.214l80.198 46.459v-3.834l-77.259-44.759z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M147.967 243.751l-.033-96.492-77.225-44.648v96.381l77.258 44.759z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M120 221.377l21.536 12.483-.011-32.421L120 189v32.377z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#99A4C2",
  fillRule: "evenodd",
  d: "M245.298 198.992v-96.381l2.939-1.699v100.214l-80.187 46.459v-3.834l77.248-44.759z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M168.05 243.751l.022-96.492 77.225-44.648v96.381l-77.247 44.759zM57.7 81.97l100.303 57.98 100.292-57.98L158.026 24 57.7 81.97z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M237.486 83.143l3.319-1.923-82.746-47.832-82.79 47.832 3.318 1.923 79.472-45.91 79.427 45.91z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6FA",
  fillRule: "evenodd",
  d: "M237.485 83.143l-79.426-45.91-79.472 45.91 79.438 45.921 79.46-45.921z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M224.421 124.728v32.399l16.552-9.589V115.15l-16.552 9.578zM199.868 138.642v32.399l16.551-9.589v-32.387l-16.551 9.577z",
  clipRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  width: 341,
  height: 242,
  x: -93,
  y: 304,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 29.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f",
  width: 341,
  height: 242,
  x: 104,
  y: 290,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 29.5
})));

function SvgBoxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 572 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.a49c5a78.svg";
export { ForwardRef as ReactComponent };